export const shoulderPainfularcText = {
  values: [
    { value: 'ShoulderPainfularc', text: 'Ja', score: 1 },
    { value: 'ShoulderPainfularc', text: 'Nei', score: 0 },
    { value: 'ShoulderPainfularc', text: 'Ikke aktuelt', score: -1 },
  ],
};
